import { http } from "../client";
export var deleteMusicArchive = function (request) {
    var data = new FormData();
    data.append("_method", "DELETE");
    return http.api
        .post("music-archives/".concat(request.musicArchiveId), data)
        .then(function (response) { return response.data.success; });
};
